export enum PersonalAreaTopic {
    DASHBOARD,
    SUPPORTERS,
    EVENTS,
}
